/**
 * Fired when element is initialized in the site builder.
 * The event will send the element's id and the element's position.
 * The sent data above will be used to initialize wrapers and other elements in
 * the site builder.
 */
export const ELEMENT_INITIALIZED = 'element:initialized';

/**
 * Fired when all elements are initialized in the site builder.
 */
export const ELEMENTS_INITIALIZED = 'elements:initialized';

/**
 * Fired when element position is changed in the site builder in result of
 * scrolling or other actions.
 */
export const ELEMENT_POSITION_CHANGED = 'element:positionChanged';

/*
 * Fired when all elements are changed in the site builder.
 */
export const ELEMENTS_CHANGE_POSITIONS = 'elements:changePositions';

/**
 * This will open the article in the article editor.
 */
export const ARTICLE_FIRE = 'article:fire';

/**
 * This will open the picture in the picture editor.
 */
export const PICTURE_CHANGE = 'picture:change';

/**
 * This will fire when the element is hovered.
 */
export const ELEMENT_MOUSEOVER = 'element:mouseover';

/**
 * This will fire when a locked element is hovered.
 */
export const LOCKED_ELEMENT_MOUSEOVER = 'locked-element:mouseover';

/**
 * This will fire when a section is clicked.
 */
export const SECTION_CLICKED = 'section:clicked';

/**
 * This will fire when a section is hovered.
 */
export const SECTION_HOVERED = 'section:hovered';

/**
 * This will fire when an element (article/picture) is clicked.
 */
export const ELEMENT_CLICKED = 'element:clicked';

/**
 * This will fire when the slide animation starts.
 */
export const SLIDE_ANIMATION_START = 'slide:animationStart';

export const SLIDE_ANIMATION_START_AFTER_DELAY =
  'slide:animationStartAfterDelay';

/**
 * This will fire when the slide animation ends.
 */
export const SLIDE_ANIMATION_END = 'slide:animationEnd';

/**
 * This will fire when blur event is triggered on the text editor.
 */
export const TEXT_EDITOR_BLUR = 'textEditor:blur';

/**
 * This will fire when the slide is changed.
 */
export const MOVE_TO_NEXT_SLIDE = 'moveToNextSlide';

/**
 * This will fire when the slide is changed.
 */
export const MOVE_TO_PREV_SLIDE = 'moveToPrevSlide';

/**
 * Collect site data event.
 */
export const COLLECT_CHANGED_BY_USER_SITE_DATA = 'collectChangedByUserSiteData';

/**
 * Collect site data success event.
 */
export const COLLECT_CHANGED_BY_USER_SITE_DATA_SUCCESS =
  'collectChangedByUserSiteDataSuccess';

/**
 * Fired when the iframe is loaded.
 */
export const WIZARD_IFRAME_LOADED = 'wizard-iframe-loaded';

export const WIZARD_BRIDGE_INITIALIZED = 'wizard-bridge-initialized';

export const INITIALIZE_WIZARD_SETTINGS = 'initialize-wizard-settings';

export const INITIALIZE_WIZARD_SETTINGS_SUCCESS =
  'initialize-wizard-settings-success';

export const GET_INITIAL_ELEMENTS = 'getInitialElements';

export const WIZARD_INIT = 'wizardInit';

export const CHANGE_SITE_COLOR = 'changeSiteColor';

export const CHANGE_SITE_COLORS = 'changeSiteColors';

export const COLLECT_ALL_AREAS = 'collectAllAreas';

export const COLLECT_ALL_AREAS_SUCCESS = 'collectAllAreasSuccess';

export const UPDATE_AREA_TEXT = 'updateAreaText';

export const ELEMENT_CHANGED = 'elementChanged';

export const CHANGE_SITE_LOGO = 'changeSiteLogo';

export const CHANGE_SITE_FONTS = 'changeSiteFonts';

/**
 * Request editable elements in a section
 */
export const GET_SECTION_EDITABLE_ELEMENTS = 'getSectionEditableElements';

/**
 * Response with editable elements in a section
 */
export const SECTION_EDITABLE_ELEMENTS = 'sectionEditableElements';

/**
 * Apply navigation style when in edit mode
 */
export const APPLY_NAVIGATION_EDIT_STYLE = 'applyNavigationEditStyle';
